(function () {
  var currentDeploy = "1781185405497";
  var freshView = "ws" + currentDeploy;

  function rescueStaleWallSagePage() {
    var root = document.getElementById("root");
    if (!root) return;

    var deploy = root.getAttribute("data-deploy") || "";
    if (deploy === currentDeploy) return;

    var params = new URLSearchParams(window.location.search || "");
    if (params.get("view") === freshView) return;

    window.location.replace(
      window.location.origin +
        "/?view=" +
        freshView +
        (window.location.hash || "")
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rescueStaleWallSagePage);
  } else {
    rescueStaleWallSagePage();
  }
})();
